export enum QueryFormat {
  GML2 = 'gml2' as any,
  GML3 = 'gml3' as any,
  JSON = 'json' as any,
  GEOJSON = 'geojson' as any,
  TEXT = 'text' as any,
  HTML = 'html' as any
}
